<app-header></app-header>
<div id="print-section">
  <div class="container-fluid py-4">
    <div class="row justify-content-center">
      <div class="col-lg-8 col-md-10 col-12">
        <div class="alert alert-success d-flex align-items-center" *ngIf="transactionId">
          <i class="pi pi-check me-2"></i>
          <div>
            <strong>Refund Payment</strong>
            <div class="small">Your refund has been processed successfully.</div>
          </div>
        </div>
        <div class="alert alert-danger d-flex align-items-center" *ngIf="!transactionId">
          <i class="pi pi-exclamation-triangle refundFailure me-2"></i>
          <div>
            <strong>Refund Payment</strong>
            <div class="small">Sorry, there was an issue processing your refund.</div>
          </div>
        </div>
        <div class="text-end mb-3">
          <button pButton type="button" class="btn btn-outline-secondary" (click)="print()">
            <i class="pi pi-print"></i> Print
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="container below_header">
    <div class="row justify-content-center">
      <div class="col-lg-8 col-md-10 col-12">
        <div *ngIf="transactionId" class="mb-2">
          <span class="fw-bold">Transaction ID:</span> {{transactionId}}
        </div>
        <div *ngIf="orderId" class="mb-2">
          <span class="fw-bold">Order ID:</span> {{orderId}}
        </div>
        <div *ngIf="invoiceId" class="mb-2">
          <span class="fw-bold">Invoice ID:</span> {{invoiceId}}
        </div>
        <div *ngIf="agency" class="mb-2">
          <span class="fw-bold">Agency:</span> {{agency}}
        </div>
        <div *ngIf="advertiser" class="mb-4">
          <span class="fw-bold">Advertiser:</span> {{advertiser}}
        </div>

        <div class="card mb-4">
          <div class="card-body">
            <div class="d-flex align-items-center mb-2">
              <i class="pi pi-credit-card payment_detail_icon me-2"></i>
              <span class="h6 mb-0">Payment Details</span>
            </div>
            <div>
              <p class="mb-1">Total Refund Amount</p>
              <p class="fs-5 fw-bold mb-0">
                <span>{{ refundAmount }}</span>
              </p>
            </div>
          </div>
        </div>

        <div *ngIf="transactionId" id="goToHome" class="text-center">
          <button pButton type="button" (click)="back($event)" class="btn btn-primary">
            <i class="fa fa-home home_icon"></i> Go Home
          </button>
        </div>
        <div *ngIf="!transactionId" id="goToHome" class="text-center">
          <button pButton type="button" (click)="back($event)" class="btn btn-danger refundFailure">
            <i class="fa fa-home home_icon"></i> Go Home
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
